export default {"src":"/_next/static/image/public/images/ic_express_boy.94300a85c2305293e55ef802552493ff.svg","height":57,"width":55};